// CustomLayout.tsx
import React, { useEffect, useMemo } from 'react';
import { Layout, LayoutProps, useAuthState, useGetIdentity } from 'react-admin';
import Menu from './custom.menu';
import CustomAppBar from './custom.appbar';
import AppExtensionProviderRegistry, { AppExtension } from '../../framework/app/app.extension.provider';
import { AnalyticsPreloadTrigger } from '../../modules/analytics/mm/components/AnalyticsPreloadTrigger';
import { RealtimeUpdatesInitializer } from '../realtime/RealtimeUpdatesInitializer';
import { getConfig } from '../../framework/config/app.config';

declare var pendo: any;

const CustomLayout: React.FC<LayoutProps> = (props) => {
  const { authenticated } = useAuthState();
  const { identity, isLoading } = useGetIdentity();
  const baseProduct =
    typeof window !== 'undefined'
      ? sessionStorage.getItem('selectedEnvProduct') || getConfig('VITE_APP_PRODUCT') || 'neo'
      : getConfig('VITE_APP_PRODUCT') || 'neo';
  const tenantAdminFlag =
    typeof window !== 'undefined' ? sessionStorage.getItem('isTenantAdmin') === 'true' : false;
  const isHybridAdmin = tenantAdminFlag && baseProduct !== 'mmadmin';

  const safeGetExtension = (key: string): AppExtension | undefined => {
    try {
      return AppExtensionProviderRegistry.getProvider(key)?.getAppExtension();
    } catch (err) {
      console.warn(`⚠️ CustomLayout: extension provider missing for key "${key}"`);
      return undefined;
    }
  };

  const defaultExtension = AppExtensionProviderRegistry.getDefaultProvider()?.getAppExtension();
  const baseExtension = safeGetExtension(baseProduct);
  const adminExtension = safeGetExtension('mmadmin');

  const menuComponent = useMemo(() => {
    const BaseMenu = baseExtension?.getMenu?.();
    const AdminMenu = adminExtension?.getMenu?.();

    if (isHybridAdmin && (BaseMenu || AdminMenu)) {
      const CombinedMenu = (menuProps: any) => (
        <>
          {BaseMenu ? <BaseMenu {...menuProps} /> : null}
          {AdminMenu ? <AdminMenu {...menuProps} hideWelcome /> : null}
        </>
      );
      return CombinedMenu;
    }

    return defaultExtension?.getMenu?.() || Menu;
  }, [adminExtension, baseExtension, defaultExtension, isHybridAdmin]);

  /*
  useEffect(() => {
    if (authenticated && !isLoading && identity) {
      // Initialize Pendo with user information

      
      const ret = pendo.initialize({
        visitor: {
          id: identity.id,
          lastName: identity.fullName,
        },
        account: {
          id: identity.id,
          accountName: identity.fullName,
          payingStatus: true,
        },
      });
    }

  }, [authenticated, isLoading, identity]);
  */
  

  return (
    <>
      {/* 🚫 PRELOADER DISABLED FOR DEBUGGING */}
      {/* <AnalyticsPreloadTrigger /> */}
      
      <Layout {...props} appBar={CustomAppBar} menu={menuComponent} />
    </>
  );
};

export default CustomLayout;

// CustomLayout.tsx
/*import { Layout, AppBar, LayoutProps } from 'react-admin';
import Menu from './custom.menu';
import CustomAppBar from './custom.appbar';


const CustomLayout = (props: LayoutProps) => <Layout {...props} appBar={CustomAppBar} menu={Menu}/>;

export default CustomLayout;
*/
